/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isroot1Inputs */

const en_entity_isroot1 = /** @type {(inputs: Entity_Isroot1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Root`)
};

const de_entity_isroot1 = /** @type {(inputs: Entity_Isroot1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Wurzel`)
};

/**
* | output |
* | --- |
* | "Is Root" |
*
* @param {Entity_Isroot1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isroot1 = /** @type {((inputs?: Entity_Isroot1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isroot1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isroot1(inputs)
	return de_entity_isroot1(inputs)
});
export { entity_isroot1 as "entity_isRoot" }